<template>
  <div class="faq-area ptb-100">
    <div class="container">
      <div class="section-title">
        <span class="top-title">FAQ’S</span>
        <h2>Our Achievements, Woven with Passion and Precision</h2>
      </div>

      <div class="faq-accordion-wrap">
        <BAccordion>
          <BAccordionItem title="How does Paid Search Marketing work?" visible>
            <p>
              Paid Search Marketing works through an auction-based system.
              Advertisers bid on specific keywords, stating the maximum amount
              they are willing to pay for each click on their ad. The search
              engine then considers the bid amount, ad relevance, and other
              factors to determine which ads will be displayed
            </p>
          </BAccordionItem>
          <BAccordionItem
            title="What are the benefits of Paid Search Marketing?"
          >
            <p>
              Paid Search Marketing works through an auction-based system.
              Advertisers bid on specific keywords, stating the maximum amount
              they are willing to pay for each click on their ad. The search
              engine then considers the bid amount, ad relevance, and other
              factors to determine which ads will be displayed
            </p>
          </BAccordionItem>
          <BAccordionItem title="Which platforms offer Paid Search Marketing?">
            <p>
              Paid Search Marketing works through an auction-based system.
              Advertisers bid on specific keywords, stating the maximum amount
              they are willing to pay for each click on their ad. The search
              engine then considers the bid amount, ad relevance, and other
              factors to determine which ads will be displayed
            </p>
          </BAccordionItem>
          <BAccordionItem
            title="How do I create a Paid Search Marketing campaign?"
          >
            <p>
              Paid Search Marketing works through an auction-based system.
              Advertisers bid on specific keywords, stating the maximum amount
              they are willing to pay for each click on their ad. The search
              engine then considers the bid amount, ad relevance, and other
              factors to determine which ads will be displayed
            </p>
          </BAccordionItem>
          <BAccordionItem
            title="What is Quality Score in Paid Search Marketing?"
          >
            <p>
              Paid Search Marketing works through an auction-based system.
              Advertisers bid on specific keywords, stating the maximum amount
              they are willing to pay for each click on their ad. The search
              engine then considers the bid amount, ad relevance, and other
              factors to determine which ads will be displayed
            </p>
          </BAccordionItem>
          <BAccordionItem
            title="Is Paid Search Marketing suitable for all businesses?"
          >
            <p>
              Paid Search Marketing works through an auction-based system.
              Advertisers bid on specific keywords, stating the maximum amount
              they are willing to pay for each click on their ad. The search
              engine then considers the bid amount, ad relevance, and other
              factors to determine which ads will be displayed
            </p>
          </BAccordionItem>
        </BAccordion>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqAccordion",
};
</script>
